import { UploadOutlined } from '@ant-design/icons';
import { useBoolean } from 'ahooks';
import {
  Button, Col,
  Form, Row, Upload,
} from 'antd';
import { HttpRequestHeader } from 'antd/es/upload/interface';

import { FetchImage } from 'components';

import { useGetHeaders } from 'hooks';
import { addQueryParamsToURL } from 'utils';

import { TFieldProps } from 'types';

import { config } from 'miles.config';

import { beforeUpload, handleImgChange } from './formImageUploadHelpers';

const { Item } = Form;

interface IImageUploadProps extends Pick<TFieldProps, 'imgWidth' | 'entityType'> {
  value?: string;
  onChange?: (value: string) => void;
}

const ImageUpload = ({ value, imgWidth, entityType, onChange }: IImageUploadProps) => {
  const [loading, { set }] = useBoolean(false);

  const headers = useGetHeaders();

  let src = '';

  if (value) {
    src = addQueryParamsToURL(`${config.apiURL}/images/${value}`, { isForView: true });
  }

  return (
    <Row align='middle'>
      {!!src && (
        <Col className='mr-4'>
          <FetchImage
            src={src}
            width={imgWidth}
            height={imgWidth}
          />
        </Col>
      )}

      <Upload
        name='file'
        maxCount={1}
        listType='picture'
        showUploadList={false}
        action={addQueryParamsToURL(`${config.apiURL}/images`, { entityType })}
        headers={{
          'X-Requested-With': null as unknown as string,
          ...headers,
        } as HttpRequestHeader}
        onChange={handleImgChange(set, onChange)}
        beforeUpload={beforeUpload}
      >
        <Button
          loading={loading}
          icon={<UploadOutlined />}
        >
          Upload
        </Button>
      </Upload>
    </Row>
  );
};

export const FormImageUpload = ({
  name,
  label,
  rules,
  tooltip,
  entityType,
  imgWidth = 80,
  itemClassName,
}: Omit<TFieldProps, 'type'>) => (
  <Item
    name={name}
    rules={rules}
    label={label}
    tooltip={tooltip}
    labelAlign='left'
    className={itemClassName}
  >
    <ImageUpload
      imgWidth={imgWidth}
      entityType={entityType}
    />
  </Item>
);
